import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "big_admin_token";

export const getToken = () => localStorage.getItem(KEY);
export const setToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));

export const admin = axios.create({ baseURL: API });
admin.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const apiError = (err, fallback = "Something went wrong.") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg).filter(Boolean).join(" ") || fallback;
  return fallback;
};

export const replyMailto = (lead, kind) => {
  const first = (lead.name || "").split(" ")[0] || "there";
  const subject = kind === "inquiries" ? `Re: your ${lead.interest} inquiry — Bossard Investment Group` : "Your Bossard investor overview — next steps";
  const body = [
    `Hi ${first},`,
    "",
    kind === "inquiries"
      ? `Thank you for reaching out about ${lead.interest.toLowerCase()}. I'd love to learn more about your goals.`
      : "Thank you for downloading the Bossard investor overview. I'd love to hear what stood out and answer any questions.",
    "",
    "Would a 15-minute call work? Pick a time here: https://calendly.com/kenbossard/15min — or simply reply with a few times that suit you.",
    "",
    "Kenneth Bossard",
    "Bossard Investment Group LLC · (240) 363-9117",
  ].join("\n");
  return `mailto:${lead.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
